<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>学生管理</Breadcrumb-item>
        <Breadcrumb-item>句子翻译</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="80" :show-message="false">
        <Row :gutter="12">
          <Col :xs="12" :sm="8" :md="6">
            <FormItem label="原句：">
              <Input v-model="queryParam.sentence" placeholder="支持模糊搜索" clearable></Input>
            </FormItem>
          </Col>
          <Col :xs="12" :sm="8" :md="6">
            <FormItem label="状态：">
              <Select v-model="queryParam.status" placeholder="全部" clearable>
                <Option :value="1">启用</Option>
                <Option :value="0">停用</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xs="12" :sm="8" :md="6">
            <Button type="primary" :loading="searchLoading" icon="search" @click="search">搜索</Button>
            <Button type="primary" icon="plus" style="margin-left: 8px" @click="openModal()">新增</Button>
          </Col>
        </Row>
      </Form>
    </div>

    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/sentenceCard/list"
          :params="queryParam" :onLoading="onLoading"></List>

    <Modal :title="formData.id ? '编辑句子' : '新增句子'" v-model="showModal" width="640" :mask-closable="false">
      <Form ref="editForm" :label-width="100" :model="formData" :rules="formRules">
        <FormItem label="原句" prop="sentence">
          <Input v-model="formData.sentence" type="textarea" :rows="3" placeholder="请输入原句"></Input>
        </FormItem>
        <FormItem label="中文翻译" prop="cnTranslate">
          <Input v-model="formData.cnTranslate" type="textarea" :rows="3" placeholder="请输入中文翻译"></Input>
        </FormItem>
        <FormItem label="音频" prop="audioUrl">
          <FileUpload :defaultFileList="defaultFileList" :num="1" @on-file-change="onFileChange"
                      text="点击或拖拽上传音频"></FileUpload>
        </FormItem>
        <FormItem label="状态">
          <Select v-model="formData.status" style="width: 160px">
            <Option :value="1">启用</Option>
            <Option :value="0">停用</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="showModal = false">取消</Button>
        <Button type="primary" :loading="saveLoading" @click="onSave">保存</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  data () {
    return {
      searchLoading: false,
      saveLoading: false,
      reload: 0,
      showModal: false,
      defaultFileList: [],
      queryParam: {
        sentence: '',
        status: null
      },
      formData: this.emptyForm(),
      formRules: {
        sentence: [{required: true, message: '请输入原句'}]
      },
      title: [
        {
          title: '原句',
          minWidth: 200,
          render: (h, params) => {
            let row = params.row
            return h('span', row.displaySentence || row.sentence || '')
          }
        },
        {title: '中文翻译', minWidth: 180, key: 'cnTranslate'},
        {
          title: '音频',
          minWidth: 200,
          render: (h, params) => {
            let url = params.row.audioUrl
            if (!url) {
              return h('span', '')
            }
            return h('audio', {
              attrs: {src: url, controls: 'controls', preload: 'none'},
              style: {width: '180px', height: '32px'}
            })
          }
        },
        {
          title: '状态',
          width: 90,
          render: (h, params) => {
            let row = params.row
            if (row.statusText) {
              return h('span', row.statusText)
            }
            return h('span', row.status === 1 ? '启用' : '停用')
          }
        },
        {title: '修改时间', minWidth: 160, key: 'gmtModified'},
        {
          title: '操作',
          width: 160,
          render: (h, params) => {
            let row = params.row
            let btns = []
            if (row.status === 1 || row.statusText === '启用') {
              btns.push(h('Button', {
                props: {type: 'warning', size: 'small'},
                style: {marginRight: '6px'},
                on: {click: () => this.changeStatus(row, 0)}
              }, '停用'))
            } else {
              btns.push(h('Button', {
                props: {type: 'success', size: 'small'},
                style: {marginRight: '6px'},
                on: {click: () => this.changeStatus(row, 1)}
              }, '启用'))
            }
            btns.push(h('Button', {
              props: {type: 'primary', size: 'small'},
              on: {click: () => this.openModal(row)}
            }, '编辑'))
            return h('div', btns)
          }
        }
      ]
    }
  },
  methods: {
    emptyForm () {
      return {
        id: null,
        sentence: '',
        cnTranslate: '',
        audioUrl: '',
        status: 1
      }
    },
    openModal (row) {
      if (row) {
        this.formData = {
          id: row.id,
          sentence: row.sentence || row.displaySentence || '',
          cnTranslate: row.cnTranslate || '',
          audioUrl: row.audioUrl || '',
          status: row.status == null ? 1 : row.status
        }
        let url = row.audioUrl
        this.defaultFileList = url ? [{name: row.audioName || url, url: url, status: 'finished'}] : []
      } else {
        this.formData = this.emptyForm()
        this.defaultFileList = []
      }
      this.showModal = true
    },
    onFileChange (files) {
      if (files && files.length) {
        this.formData.audioUrl = files[0].url
      } else {
        this.formData.audioUrl = ''
      }
    },
    onSave () {
      if (!this.formData.sentence) {
        this.$Message.warning('请输入原句')
        return
      }
      let self = this
      self.saveLoading = true
      self.$http.post('/sentenceCard/save', {}, {
        transformRequest: [function () {
          return JSON.stringify(self.formData)
        }],
        headers: {'Content-Type': 'application/json;charset=utf-8'}
      }).then(function (res) {
        self.saveLoading = false
        if (res.status === 'ok') {
          self.$Message.success('保存成功')
          self.showModal = false
          self.search()
        }
      }).catch(function () {
        self.saveLoading = false
      })
    },
    changeStatus (row, status) {
      let self = this
      self.$http.post('/sentenceCard/updateStatus', {id: row.id, status: status}).then(function (res) {
        if (res.status === 'ok') {
          self.$Message.success('操作成功')
          self.search()
        }
      })
    },
    search () {
      this.reload = new Date().getTime()
    },
    onLoading (loading) {
      this.searchLoading = loading
    }
  }
}
</script>



// WEBPACK FOOTER //
// SentenceCardList.vue?424b76af